module.exports = __webpack_public_path__ + "static/media/ShulspaceLogo.418730a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ShulspaceLogo.svg
// module id = 990
// module chunks = 0